"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ControlledInput = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var styles = {
  "ControlledInput": "ControlledInput__ControlledInput___2XK3j",
  "ControlledInput--disabled": "ControlledInput__ControlledInput--disabled___3prPF"
};
var defaultProps = {
  testId: 'cf-ui-controlled-input',
  required: false,
  disabled: false,
  type: 'checkbox',
  willBlurOnEsc: true
};

var ControlledInput = function ControlledInput(props) {
  var className = props.className,
      id = props.id,
      testId = props.testId,
      required = props.required,
      disabled = props.disabled,
      _onFocus = props.onFocus,
      _onBlur = props.onBlur,
      name = props.name,
      _onChange = props.onChange,
      checked = props.checked,
      value = props.value,
      type = props.type,
      labelText = props.labelText,
      willBlurOnEsc = props.willBlurOnEsc,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "id", "testId", "required", "disabled", "onFocus", "onBlur", "name", "onChange", "checked", "value", "type", "labelText", "willBlurOnEsc"]);
  var classNames = (0, _classnames["default"])(styles['ControlledInput'], className, (0, _defineProperty2["default"])({}, styles['ControlledInput--disabled'], disabled));
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    e.persist();

    if (e.nativeEvent.code === 'Escape' && willBlurOnEsc) {
      e.currentTarget.blur();
    }
  }, [willBlurOnEsc]);
  return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    className: classNames,
    value: value,
    name: name,
    checked: props.checked,
    type: type,
    "data-test-id": testId,
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e);
      }
    },
    onBlur: function onBlur(e) {
      if (_onBlur) {
        _onBlur(e);
      }
    },
    onFocus: function onFocus(e) {
      if (_onFocus) {
        _onFocus(e);
      }
    },
    "aria-label": labelText,
    id: id,
    required: required,
    disabled: disabled,
    onKeyDown: handleKeyDown
  }, otherProps));
};

exports.ControlledInput = ControlledInput;
ControlledInput.defaultProps = defaultProps;
var _default = ControlledInput;
exports["default"] = _default;